// Environment config (Vite VITE_* build-time env). Dev defaults target the v3-dev
// edge directly; the admin SPA is served at root on its dedicated host
// https://v3-admin-dev.ls-dg.net/. X-Client-Key is a feature gate, not a secret,
// so it may live in web config.
//
// Client identity = c-ls-admin (restful 00 §A.7/§A.8, 2026-06-13): the console
// has its OWN cookie client, so its refresh cookie (refresh_token__c-ls-admin,
// host-only) never collides with the webapp's — both SPAs hit the same API
// host, and the previous c-ls-web reuse meant "last login wins" across apps.

export interface AppConfig {
  envName: string;
  apiBase: string;
  clientId: string;
  clientKey: string;
  region: string;
  /** Platform admin email domain from deployment settings, without the leading @. */
  platformPrimaryDomain: string;
  /** Vite base path the SPA is mounted under (router basename). Root host uses '/'. */
  basePath: string;
}

const env = import.meta.env;

export function normalizeConfiguredDomain(domain: string | undefined): string {
  const trimmed = (domain ?? '').trim().toLowerCase().replace(/^@/, '').replace(/\.$/, '');
  if (trimmed.includes('://') || trimmed.includes('/')) return '';
  return trimmed;
}

export const config: AppConfig = {
  envName: env.VITE_ENV_NAME ?? 'dev',
  apiBase: env.VITE_API_BASE ?? 'https://v3-api-dev.ls-dg.net',
  clientId: env.VITE_CLIENT_ID ?? 'c-ls-admin',
  clientKey: env.VITE_CLIENT_KEY ?? 'dev-key-admin',
  region: env.VITE_REGION ?? 'apac',
  platformPrimaryDomain: normalizeConfiguredDomain(env.VITE_PLATFORM_PRIMARY_DOMAIN),
  // import.meta.env.BASE_URL is injected by Vite from vite.config base ('/').
  basePath: env.BASE_URL ?? '/',
};

/** Router basename — BASE_URL without the trailing slash; '' when mounted at root. */
export const routerBasename: string = config.basePath.replace(/\/$/, '');
